import { Property, SelectInput } from '@/components/form/fields/select/SelectInput';
import SiInformation from '@/icons/SiInformation';
import { PeripheralFinanceModel } from '@/services/api/contracts/financemodels';
import {
  useSelectCapitalPurchaseForPeripheral,
  useSelectPeripheralFinanceModel,
  useSelectedPeripheralFinanceModel
} from '@/services/catalogue/useCustomerCatalogueService';
import { FC } from 'react';
import { FinanceModelBulletPoint } from './FinanceModelCard';
import { CAPITAL_PURCHASE_ID, CAPITAL_PURCHASE_OPTION } from './const';

interface Props {
  models: PeripheralFinanceModel[];
}

export const PeripheralFinanceModelCard: FC<Props> = ({ models }) => {
  const selectedModel = useSelectedPeripheralFinanceModel();
  const selectModel = useSelectPeripheralFinanceModel();
  const selectCapitalPurchase = useSelectCapitalPurchaseForPeripheral();

  const selectedModelOptions: Property[] = [
    CAPITAL_PURCHASE_OPTION,
    ...models.map(m => ({
      name: m.name,
      id: m.id
    }))
  ];

  const onModelChange = (value: Property | null) => {
    if (value && value.id) {
      if (value.id === CAPITAL_PURCHASE_ID) {
        selectCapitalPurchase().catch(console.error);
      } else {
        const model = models.find(m => m.id === value?.id);
        if (!model) throw new Error(`Missing model with id: ${value?.id}`);
        selectModel(model).catch(console.error);
      }
    }
  };

  return (
    <div className="flex items-stretch border bg-white rounded-md">
      <div className="py-2 px-7 border-r text-[60px] flex items-center">
        <SiInformation />
      </div>
      <div className="px-5 py-5 space-y-2">
        <div className="flex items-center gap-1">
          <span className="text-xl font-semibold leading-tight">Peripherals</span>
        </div>
        <SelectInput
          className="w-[300px]"
          id={``}
          options={selectedModelOptions}
          value={selectedModelOptions.find(o => o.id === selectedModel?.id) || CAPITAL_PURCHASE_OPTION}
          onChange={onModelChange}
        />
      </div>
      {selectedModel && (
        <div className="px-5 py-2 flex-1 border-l flex items-center hidden">
          <div className="grid grid-rows-3 grid-flow-col gap-1">
            {selectedModel.term && (
              <FinanceModelBulletPoint>{`${selectedModel.term} year term`}</FinanceModelBulletPoint>
            )}
            {selectedModel.value && (
              <FinanceModelBulletPoint>{`${selectedModel.value}% value`}</FinanceModelBulletPoint>
            )}
            {selectedModel.pcmFactor && (
              <FinanceModelBulletPoint>{`${selectedModel.pcmFactor} PCM`}</FinanceModelBulletPoint>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
